import { GET_STORE_INFO_REQUEST } from '../actionTypes/OrderActionTypes';

export const getStoreInfo = (storeId) => ({
    type: GET_STORE_INFO_REQUEST,
    storeId,
});

export default getStoreInfo;
